/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientFlowActions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ChairsAction from './ChairsAction/index'
import NewPatient from './NewPatient/index'
import React from 'react'
import WaitingRoomAction from './WaitingRoomAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientFlowActions({
  children,
  viewPath = "/App/Account/Topbar/PatientFlowActions"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="PatientFlowActions.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-Z20atMR': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<NewPatient
  viewPath={`${viewPath}/NewPatient`}
/>
<WaitingRoomAction
  viewPath={`${viewPath}/WaitingRoomAction`}
/>
<ChairsAction
  viewPath={`${viewPath}/ChairsAction`}
/>
</div>
{children}
</React.Fragment>)
}